import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "gatsby";
import { globalHistory } from "@reach/router";

import CartList from "../cards/CardList";

import { CartContentContext } from "../../context/CartContentContext";
import { toast } from "react-toastify";
import Modal from "react-modal";

import { TfiMenu } from "react-icons/tfi";
import { VscSearch } from "react-icons/vsc";
import { AiOutlineHeart } from "react-icons/ai";
import { BsCart3, BsLock, BsImage } from "react-icons/bs";
import { BiQrScan } from "react-icons/bi";
import {
  HeaderComponent,
  Container,
  Menu,
  Cart,
  LoginUser,
} from "./Style/HeaderStyle";

import client from "../../apollo/client";

import { AuthUserContext } from "../../context/AuthUser";

import closeIcon from "../../images/icons/close.icon2.svg";

import textileLibraryLogo from "../../images/textile_library_logo.png";

import MenuFilter from "../menu/Menu";

import MenuSearch from "../MenuSearch";
import useComponentVisible from "../../hooks/useComponentVisible";
import { CURRENT_USER, USER_DATA } from "../../querys/index";
import { useQuery } from "@apollo/client";
import { GET_SHIPPING_CART } from "../../mutations";
import ScanProduct from "../scan-product";

const Header = () => {
  const { data } = useQuery(CURRENT_USER);

  const { authUser, setAuthUser } = useContext(AuthUserContext);

  const { data: userData } = useQuery(USER_DATA, {
    variables: { id: authUser ? authUser?.user?.id || data?.me?.id : "" },
  });

  const { data: cartList } = useQuery(GET_SHIPPING_CART, {
    variables: {
      id: authUser ? authUser?.user?.id || data?.me?.id : "",
    },
  });

  useEffect(() => {}, [data, authUser]);

  const {
    cartContent,
    setCartContent,
    setSwatchContent,
    setTotalPrice,
    setShippingAddress,
    setShippingTotalCost,
    setTotalAmout,
    setDataCetcurrentUser,
  } = useContext(CartContentContext);
  useEffect(() => {}, [cartContent]);

  const handleShowMenu = () => {
    const ELEMENT = document.querySelector(".item-menu");
    if (ELEMENT.classList.contains("hiddeMenu")) {
      ELEMENT.classList.remove("hiddeMenu");
      ELEMENT.classList.add("showMenu");
    } else if (ELEMENT.classList.contains("showMenu")) {
      ELEMENT.classList.add("hiddeMenu");
      ELEMENT.classList.remove("showMenu");
    } else {
      ELEMENT.classList.add("showMenu");
    }
  };

  const handleLogout = () => {
    client.clearStore();
    localStorage.removeItem("token");
    localStorage.removeItem("user_data");
    setAuthUser({ logged: false, user: {} });
    handleShowMenu();
    // client.resetStore()
    window.location.href = "/login";
    // window.location.href = "/login";
    // navigate("/login");

    setCartContent([]);
    setSwatchContent([]);
    setTotalPrice(0);
    setShippingAddress({});
    setShippingTotalCost(0);
    setTotalAmout(0);
    setDataCetcurrentUser([]);

    toast.warning("Log out successfully!");
  };

  const handleAccessLogin = () => {
    toast.error("Login to access the cart");
  };

  // const [searchVal, setSearchVal] = useState(false);
  // const handleOpenSearch = () => {
  //   const Element = document.getElementById("search-container");
  //   if (searchVal) {
  //     setSearchVal(false);
  //     Element.classList.remove("showSearch");
  //   } else {
  //     setSearchVal(true);
  //     Element.classList.add("showSearch");
  //   }
  // };

  const [isSearchOpen, setIsSearchOpen] = useState(false); // Controlamos el estado
  const searchRef = useRef(null);
  const handleOpenSearch = (event) => {
    if (event) {
      event.stopPropagation(); // Evitamos que el evento de clic se propague al documento
    }
    setIsSearchOpen((prev) => !prev); // Alternamos entre abrir/cerrar
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchOpen(false); // Cerramos el menú si el clic es fuera del contenedor
      }
    };

    // Añadimos el listener para detectar clics fuera del componente
    document.addEventListener("mousedown", handleClickOutside);

    // Limpiamos el listener al desmontar el componente
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setCartContent({
      id: cartList?.cartItems.data[0]?.id,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartList, authUser]);

  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const [showCamera, setShowCamera] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [pathname, setPathname] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const getNormalizedPathname = (nextPathname) => nextPathname.replace(/\/$/, "");

    setPathname(getNormalizedPathname(globalHistory.location.pathname));

    const unsubscribe = globalHistory.listen(({ location }) => {
      setPathname(getNormalizedPathname(location.pathname));
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const mobileHeaderTitle =
    isMobile && pathname === "/japan-trend-map"
      ? "JAPAN TREND MAP"
      : "Textile Library";

  const showMobileJapanTrendMapTitle =
    isMobile && pathname === "/japan-trend-map";

  return (
    <>
      {/* <MenuFilter /> */}
      <HeaderComponent className="container-fluid">
        <Container className="container-fluid">
          <div className="u-display-flex u-align-center u-height-100">
            <Menu onClick={handleShowMenu}>
              <TfiMenu />
            </Menu>
            <Link to={"/"} className="u-text-center title-header" style={{ fontWeight: 900, color: "#000" }}>
              {showMobileJapanTrendMapTitle ? (
                <span style={{ fontWeight: 900, color: "#000" }}>JAPAN TREND MAP</span>
              ) : (
                <img src={textileLibraryLogo} alt="" />
              )}
            </Link>
            <Link to={"/"} className="u-text-center title-header-only-text">
              Textile Library
            </Link>
            <div className="top-menu-desktop">
              <MenuFilter handleShowMenu={() => {}} />
            </div>
          </div>
          {!authUser.logged && !localStorage.getItem("token") ? (
            <LoginUser className="container-login">
              {/* <Link to="/ai-search" className="u-icon-size-23" aria-label="Image search">
                <BsImage />
              </Link> */}

              <Link to="/login" className="u-icon-size-23">
                {/* <img src={lockIcon} alt="Login" /> */}
                <BsLock />
              </Link>

              <Cart>
                <div
                  className="btn-cart u-icon-size-23"
                  onClick={handleAccessLogin}
                  role="button"
                  tabIndex="0"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleAccessLogin();
                    }
                  }}
                >
                  <BsCart3 />
                </div>
              </Cart>
            </LoginUser>
          ) : (
            <>
              <LoginUser>
                {/* <Link to="/ai-search" className="u-icon-size-23" aria-label="Image search">
                  <BsImage />
                </Link> */}

                {authUser.typeCustomer === "Admin" ? (
                  <div
                    onClick={() => setShowCamera((showCamera) => !showCamera)}
                    role="button"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setShowCamera((showCamera) => !showCamera);
                      }
                    }}
                    className="u-icon-size-23 hidde-qrscan-button"
                  >
                    <BiQrScan />
                  </div>
                ) : (
                  ""
                )}

                <div ref={searchRef}>
                  <div
                    onClick={() => handleOpenSearch()}
                    className="u-icon-size-23 u-cursor-pointer"
                    role="button"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleOpenSearch();
                      }
                    }}
                  >
                    <VscSearch />
                  </div>
                  {isSearchOpen && (
                    <MenuSearch
                      user={authUser?.user?.username}
                      handleOpenSearch={handleOpenSearch}
                    />
                  )}
                </div>

                <Link to="/favorites" className="u-icon-size-23">
                  <AiOutlineHeart />
                </Link>

                <Cart ref={ref}>
                  <div
                    className="btn-cart u-icon-size-23"
                    onClick={() => setIsComponentVisible(true)}
                    role="button"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setIsComponentVisible(true);
                      }
                    }}
                  >
                    {cartList?.cartItems?.data[0] && (
                      <>
                        {cartList?.cartItems?.data[0]?.attributes?.cartitem
                          .length > 0 && (
                          <div className="quantity-items">
                            {
                              cartList?.cartItems?.data[0]?.attributes?.cartitem
                                ?.length
                            }
                          </div>
                        )}
                      </>
                    )}

                    <BsCart3 />
                  </div>

                  {isComponentVisible && (
                    <CartList
                      data={cartList?.cartItems?.data[0]}
                      setIsComponentVisible={setIsComponentVisible}
                    />
                  )}
                </Cart>
              </LoginUser>
            </>
          )}
        </Container>
      </HeaderComponent>
      <div className="container-menu item-menu">
        <div
          className="backdrop"
          onClick={handleShowMenu}
          role="button"
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleShowMenu();
            }
          }}
          aria-label="backdrop"
        ></div>
        <div className="container-menu__box newMenu">
          <button
            className="container-menu__btn-close"
            onClick={handleShowMenu}
          >
            <img src={closeIcon} alt="Close" />
          </button>

          {!authUser.logged && !localStorage.getItem("token") ? (
            ""
          ) : (
            <>
              <div className="mobileMainMenu">
                <div className="top-menu-responsive">
                  <MenuFilter handleShowMenu={handleShowMenu} />
                </div>
              </div>
            </>
          )}

          <div className="newMenu1">
            {!authUser.logged && !localStorage.getItem("token") ? (
              ""
            ) : (
              <div>
                <p className="menuSubtitle">My Account</p>
                <ul className="margin-bottom30">
                  <li>
                    <Link onClick={handleShowMenu} to="/favorites">
                      Favorite
                    </Link>
                  </li>
                  <li>
                    <Link onClick={handleShowMenu} to="/order-history">
                      My Orders
                    </Link>
                  </li>
                  <li>
                    <Link onClick={handleShowMenu} to="/edit-info">
                      User Information
                    </Link>
                  </li>
                  {/* <li>
                    <Link onClick={handleShowMenu} to="/member/history">
                      AI Search History
                    </Link>
                  </li> */}
                  <li>
                    <Link onClick={handleShowMenu} to="/edit-address">
                      My Address
                    </Link>
                  </li>

                  {authUser.logged ? (
                    <li>
                      <span
                        className="container-menu__btn-logout"
                        onClick={() => handleLogout()}
                        role="button"
                        tabIndex="0"
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            handleLogout();
                          }
                        }}
                      >
                        Logout
                      </span>
                    </li>
                  ) : (
                    ""
                  )}

                  {authUser.typeCustomer === "Admin" && (
                    <li>
                      <Link onClick={handleShowMenu} to="/orders">
                        Orders
                      </Link>
                    </li>
                  )}
                </ul>
                <hr></hr>
              </div>
            )}

            <p className="menuSubtitle">Help</p>
            <ul className="margin-bottom30">
              <li>
                <Link onClick={handleShowMenu} to="/contact-us">
                  Contact Us
                </Link>
              </li>
            </ul>
            <hr />
            <ul className="margin-bottom30">
              <li>
                <Link to="/japan-trend-map" onClick={() => handleShowMenu()}>
                  Japan Trend Map
                </Link>
              </li>
            </ul>

            <ul className="margin-bottom30 u-display-flex u-margin-top-2">
              <li>
                <Link
                  style={{ fontSize: "12px" }}
                  to="/terms-and-conditions"
                  onClick={() => handleShowMenu()}
                >
                  Terms and Conditions
                </Link>
              </li>
              <li style={{ marginLeft: "20px" }}>
                <Link
                  style={{ fontSize: "12px" }}
                  to="/privacy-policy"
                  onClick={() => handleShowMenu()}
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Modal isOpen={showCamera} className="modal-styles-qr">
        <ScanProduct setShowCamera={setShowCamera} />
      </Modal>
    </>
  );
};

export default Header;
